import React, { useState } from 'react';

export default function Contact() {
  const BASE_URL = 'https://node.insuranceadvisors.pk';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    insurance_type: '',
    message: '',
    contactNumber: '',
  });
  const [popup, setPopup] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${BASE_URL}/api/saveContact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setPopup(true); // Show success popup
        setFormData({ name: '', email: '', insurance_type: '', message: '', contactNumber: '' });
        setTimeout(() => setPopup(false), 3000); // Hide popup after 3 seconds
      } else {
        console.error('Error submitting form');
      }
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  return (
    <div>
      <section id="contact" className="contact">
        <div className="container">
          <div className="section-title">
            <h3 className="hd1">CONTACT</h3>
            <p>Feel free to contact us 24/7</p>
          </div>

          <div className="row" data-aos="fade-up">
            <div className="col-lg-6">
              <div className="info-box mb-4">
                <i className="bx bx-map"></i>
                <h3>Our Address</h3>
                <p>1009 F Commercial, LakeCity Meadows(Ex Statelife Housing Society) LAHORE</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="info-box mb-4">
                <i className="bx bx-envelope"></i>
                <h3>Email Us</h3>
                <p>
                  <a href="mailto:info@insuranceadvisors.pk" className="email-link">info@insuranceadvisors.pk</a>
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="info-box mb-4">
                <i className="bx bx-phone-call"></i>
                <h3>Call Us</h3>
                <p>
                  <a href="tel:03111123026" className="phone-link">03-111-123-026</a>
                </p>
              </div>
            </div>
          </div>

          <div className="row" data-aos="fade-up">
            <div className="col-sm-6">
              <iframe
                className="mb-4 mb-lg-0 map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3403.8843426377794!2d74.39771092422792!3d31.444850850871752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3919070040d725cd%3A0x8a754e6d77342d26!2sLake%20City%20Meadows!5e0!3m2!1sen!2s!4v1747399221445!5m2!1sen!2s"
                width="100%"
                style={{ height: '440px' }}
                title="Google Map"
              ></iframe>
            </div>

            <div className="col-sm-6">
              {/* Success Popup */}
              {popup && (
                <div className="popup">
                  <p>Your message has been submitted successfully!</p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="php-email-form">
                <div className="row">
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      id="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group mt-3 mt-md-0">
  <input
    type="email"
    name="email"
    className="form-control email-input"
    id="email"
    placeholder="Your Email"
    value={formData.email}
    onChange={handleChange}
    required
  />
</div>
                </div>
                <div className="form-group mt-3">
  <select
    name="insurance_type"
    className="form-control insurance-select"
    id="insurance_type"
    value={formData.insurance_type}
    onChange={handleChange}
    required
  >
    <option value="" disabled selected className="placeholder-option">
      Select a type of insurance
    </option>
    <option value="travel">Travel</option>
    <option value="car">Car</option>
    <option value="health">Health</option>
    <option value="bike">Bike</option>
    <option value="life">Life</option>
  </select>
</div>

                <div className="form-group mt-3">
                  <input
                    type="text"
                    name="contactNumber"
                    className="form-control"
                    id="contact"
                    placeholder="Your Contact Number"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group mt-3">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="5"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="my-4"></div>
                <div className="text-center">
                  <button type="submit">Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Popup Styling */}
      <style jsx>{`
        .popup {
          position: fixed;
          top: 20%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: #28a745;
          color: white;
          padding: 15px 25px;
          border-radius: 5px;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
          z-index: 1000;
          text-align: center;
        }
      `}</style>
    </div>
  );
}
